import { QR_FOLDERS } from "@/apollo/queries/qr";
import { QR_CREATE_FOLDER, QR_RENAME_FOLDER } from "@/apollo/mutations/qr";
import { exMut, exQue } from "@/utils/gql";

// Carpetas con que la empresa agrupa sus códigos QR (un solo nivel, hasta 200).
// Cada una es { id, name, version, count, updatedAt }: `count` incluye los QR
// archivados, y `version` hay que devolverla al renombrar porque el servidor
// rechaza la edición si la carpeta cambió mientras tanto.
//
// El estado es una función, y no un objeto como en el store de EPP, para que
// cada store parta de arreglos nuevos y para poder volver a empezar desde CLEAR
// (storeQr.js) al cerrar sesión: las carpetas de una empresa no deben verse
// mientras carga la siguiente sesión.
export const CarpetasState = () => ({
  carpetas: [],
  carpetasCargando: false,
});

export const CarpetasMutations = {
  setCarpetas(state, carpetas) {
    state.carpetas = carpetas;
  },
  setCarpetasCargando(state, cargando) {
    state.carpetasCargando = cargando;
  },
};

export const CarpetasActions = {
  // Carga la lista. Si falla avisa con un toast y vuelve a lanzar el error, para
  // que la pantalla decida qué hacer.
  async getCarpetas({ commit }) {
    commit("setCarpetasCargando", true);
    try {
      const carpetas = await exQue(
        QR_FOLDERS,
        {},
        true,
        "",
        "No se pudieron cargar las carpetas",
      );
      commit("setCarpetas", Array.isArray(carpetas) ? carpetas : []);
      return carpetas;
    } finally {
      commit("setCarpetasCargando", false);
    }
  },

  // Crea una carpeta. Devuelve la carpeta creada, o null si el servidor la
  // rechazó (nombre repetido, límite de 200...): exMut ya avisó con su mensaje.
  async crearCarpeta({ dispatch }, nombre) {
    const creada = await exMut(
      QR_CREATE_FOLDER,
      { name: nombre },
      "Carpeta creada correctamente",
      "No se pudo crear la carpeta",
    );
    // Ya se creó: si falla recargar la lista, exQue avisa y la creación no pasa
    // por fallida
    if (creada) await dispatch("getCarpetas").catch(() => null);
    return creada;
  },

  // Renombra una carpeta. `version` es la que trae la lista: si otra persona la
  // cambió antes, el servidor responde "La carpeta cambió. Recarga antes de
  // renombrar." Por eso la lista se recarga también cuando falla, y el siguiente
  // intento ya parte de la versión nueva. Devuelve la carpeta o null.
  async renombrarCarpeta({ dispatch }, { id, version, nombre }) {
    const renombrada = await exMut(
      QR_RENAME_FOLDER,
      { id, version, name: nombre },
      "Carpeta actualizada correctamente",
      "No se pudo actualizar la carpeta",
    );
    await dispatch("getCarpetas").catch(() => null);
    return renombrada;
  },
};
